import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { initSentry } from '@aosenuma/lib-supabase';
import { App } from './App';

import '@aosenuma/ui/styles/tokens.css';
import '@aosenuma/ui/styles/globals.css';
import '@aosenuma/ui/styles/pagination.css';
import '@aosenuma/sig-viewer/styles/toolbar.css';
import './styles/hero.css';

// Sentry: no-op si VITE_PUBLIC_SENTRY_DSN no está set (dev sin proyecto Sentry).
// Llamamos antes de createRoot para capturar errores del primer render.
void initSentry({ app: 'landing' });

// Service Worker (ver nota crítica en equipo/main.tsx — sin reload manual).
if ('serviceWorker' in navigator) {
  void import('virtual:pwa-register').then(({ registerSW }) => {
    registerSW({ immediate: true });
  }).catch(() => { /* dev mode */ });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
